<template>
    <div class="__l">
        <h1 class="title">Containers</h1>
        <div class="actions right text-right">
            <button class="btn-primary" type="button" @click="createContainer">Create Container</button>
        </div>
        <input type="text" v-model="search" class="form-field py-4 px-6" ref="searchbar"
               placeholder="Search for Containers" @keyup.enter="handleSearch">
        <div v-if="results.data">
            <p>The total number of results for <strong>"{{ search }}"</strong> is <strong>{{ results.total }}</strong>
            </p>
        </div>
        <div class="results-list">
            <div class="results-row">
                <div class="results-head" data-width="10%">ID</div>
                <div class="results-head" data-width="40%">Name</div>
                <div class="results-head" data-width="50%">Domain</div>
            </div>

            <template v-if="results.data">
                <div class="results-row" v-for="(result, index) in results.data" :key="index"
                     @click="handleSelectedContainer(result)">
                    <div class="results-cell" data-width="10%">{{ result.id }}</div>
                    <div class="results-cell" data-width="40%">{{ result.name }}</div>
                    <div class="results-cell" data-width="50%">{{ result.domain }}</div>
                </div>
                <pagination v-model="page" :records="results.total" :per-page="25"
                            @paginate="loadData"></pagination>
            </template>
            <div class="results-row" v-if="!results.data">
                <div class="results-span text-center" data-width="100%">
                    <p>No results found</p>
                </div>
            </div>
        </div>
        <router-view v-slot="{ Component }">
            <transition name="drop-in" mode="in-out">
                <component :is="Component"></component>
            </transition>
        </router-view>
    </div>
</template>

<script>
import ContainerView from './View'
import Pagination from 'v-pagination-3'

export default {
    name: 'Containers',
    props: {
        //
    },
    data() {
        return {
            search: null,
            results: {},
            page: 1,
        }
    },
    components: {
        Pagination,
        ContainerView,
    },
    mounted() {
        window.setTimeout(function () {
            this.$refs.searchbar.focus()
        }.bind(this), 100)

        this.setMetaTitle('List Containers | JournoLink Control')
    },
    methods: {
        handleSearch() {
            this.loadData()
        },
        /**
         * Load the results from the data provider
         *
         * @return {void}
         */
        loadData() {
            axios.get(route('containers.list'), {
                params: {
                    term: this.search,
                    page: this.page,
                },
            })
                .then(response => {
                    this.results = response.data.results
                })
                .catch(e => {
                    console.error({e})
                })
        },
        /**
         * Handle the selection of a Container
         *
         * @param  {Object} container
         * @return {void}
         */
        handleSelectedContainer(container) {
            this.$router.push({name: 'containers.show', params: {containerId: container.id}})
        },
        /**
         * create a new Container
         *
         * @return {void}
         */
        createContainer() {
            this.$router.push({name: 'containers.create'})
        }
    },
    beforeRouteUpdate(to, from, next) {
        if (to && to.name === 'containers.list') {
            this.setMetaTitle('List Containers | JournoLink Control')
            this.loadData()
        }

        if (to && to.params.newContainer) {
            window.setTimeout(() => {
                this.handleSelectedContainer(to.params.newContainer)
            }, 500)

            next()
        }

        next()
    },
}
</script>

<style lang="less">

</style>
